import { GroupsFileProviderDisplayName } from './loadProviders.locstring.json';
import loc from 'owa-localize';
import { load, setLoadState } from '../actions/internalActions';
import { loadProviders } from '../actions/publicActions';
import { providersLoaded } from '../actions/subscribableActions';
import { getProviderLoadState } from '../selectors/getProviderLoadState';
import getAttachmentDataProviders from '../services/getAttachmentDataProviders';
import FileProviderViewState from '../store/schema/FileProviderViewState';
import { ProviderLoadStateOption } from '../store/schema/ProviderLoadStateOption';
import createFileProvidersViewState from '../utils/createFileProvidersViewState';
import createMailDataProvider from '../utils/createMailDataProvider';
import isFileProviderEnabled from '../utils/isFileProviderEnabled';
import AttachmentDataProvider from 'owa-service/lib/contract/AttachmentDataProvider';
import OneDriveProScopeType from 'owa-service/lib/contract/OneDriveProScopeType';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

import { orchestrator } from 'satcheljs';
import {
    FILE_PROVIDERS_LIST,
    FileProviderType,
    ClientOnlyFileProviderType,
} from '../utils/constants';

orchestrator(loadProviders, actionMessage => {
    loadProvidersOrchestrator(actionMessage.onLoaded, actionMessage.onError);
});

export default async function loadProvidersOrchestrator(
    onLoaded: (providers: FileProviderViewState[]) => void,
    onError: (error: Error) => void
) {
    if (getProviderLoadState() === ProviderLoadStateOption.NotLoaded) {
        setLoadState(ProviderLoadStateOption.Loading);

        let attachmentDataProviders: AttachmentDataProvider[];
        try {
            attachmentDataProviders = await getAttachmentDataProviders();
        } catch (error) {
            setLoadState(ProviderLoadStateOption.NotLoaded);
            onError?.(error);
            return;
        }

        // TODO VSO# 32109 Move mail message creator to the server
        const mailDataProvider = createMailDataProvider();
        attachmentDataProviders.push(mailDataProvider);

        const providers = attachmentDataProviders.filter(
            provider =>
                FILE_PROVIDERS_LIST.indexOf(provider.Type) > -1 &&
                isFileProviderEnabled(provider.Type as FileProviderType)
        );

        // TODO VSO# 33055 Consider supporting groups file provider on server
        const fileProviderViewStates = createFileProvidersViewState(providers);
        if (!!fileProviderViewStates && !isConsumer()) {
            fileProviderViewStates.splice(0, 0, getGroupsFileProvider(fileProviderViewStates[0]));
        }
        load(fileProviderViewStates);
        setLoadState(ProviderLoadStateOption.Loaded);
        onLoaded?.(fileProviderViewStates);
        providersLoaded(fileProviderViewStates);
    }
}

function getGroupsFileProvider(oneDrive: FileProviderViewState): FileProviderViewState {
    const groupsScope = {
        __type: 'OneDriveProScope:#Exchange',
        Type: OneDriveProScopeType.Groups,
        DisplayName: '',
    };
    const groupsProvider = {
        ...oneDrive,
        scopes: [groupsScope],
        isPrimaryProvider: false,
        viewType: ClientOnlyFileProviderType.Groups,
        name: loc(GroupsFileProviderDisplayName),
        associatedWithPrimaryProvider: true,
        usesGroupsViewAtTopLevel: true,
    };

    return groupsProvider;
}
